<template>
  <div>
    <!-- ======= Portfolio Section ======= -->

    <div id="portfolio" class="container-fluid service pb-5 portfolio">
      <div class="container pb-5">
        <div class="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style="max-width: 800px">
          <div class="section-title">
            <h4 class="text-primary">Our Gallery</h4>
            <p>
              We're a forcused on creating change & giving room for sustainability
            </p>
          </div>
        </div>

        <div class="container py-5">
  <div class="row align-items-stretch">
    <!-- Left Side: 4 Mini Divs (2x2 grid) -->
    <div class="col-12 col-lg-8">
      <div class="row">
        <div
          v-for="(images, index) in galleries.slice(0, 4)"
          :key="'mini-' + index"
          class="col-6 mb-4 d-flex"
        >
          <div class="gallery-div small-div flex-fill position-relative overflow-hidden rounded shadow-sm">
            <div class="slider d-flex" :style="{ animationDuration: animationDuration + 's' }">
              <img
                v-for="(img, idx) in randomizeImages(images)"
                :key="idx"
                :src="img"
                class="img-fluid flex-shrink-0 gallery-img"
                loading="lazy"
                alt="Gallery Image"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Right Side: Vertical Div -->
    <div class="col-12 col-lg-4 d-flex">
      <div class="gallery-div vertical-div flex-fill position-relative overflow-hidden rounded shadow-sm">
        <div class="slider d-flex" :style="{ animationDuration: animationDuration + 's' }">
          <img
            v-for="(img, idx) in randomizeImages(galleries[4] || [])"
            :key="'vertical-' + idx"
            :src="img"
            class="img-fluid flex-shrink-0 gallery-img"
            loading="lazy"
            alt="Gallery Image"
          />
        </div>
      </div>
    </div>
  </div>
</div>


      </div>
    </div>
    <!-- End of portfolio -->

  </div>
</template>

<script>
export default {
  data() {
    return {
      galleries: [],   // will be filled from backend
      animationDuration: 10, // seconds
    };
  },
  created() {
    // load Cloudinary images when component mounts
    this.loadImages("NGO");
  },
  methods: {
    
    // Function to fetch images dynamically from Spring Boot backend
    async loadImages(folder) {
  try {

    // const response = await fetch(`https://afc-api-h9gthqacb2h8aucp.uaenorth-01.azurewebsites.net/api/images/${folder}`);
    const response = await fetch(`${process.env.VUE_APP_API_BASE_URL}api/images/${folder}`);
    const imageUrls = await response.json();

    // Shuffle all images once
    const shuffled = this.randomizeImages(imageUrls);

    // Split into 6 chunks (to match your template structure)
    const chunkSize = Math.ceil(shuffled.length / 6);
    this.galleries = Array.from({ length: 6 }, (_, i) =>
      shuffled.slice(i * chunkSize, (i + 1) * chunkSize)
    );

  } catch (err) {
    console.error("Failed to load images:", err);
  }
},


    // Shuffle images randomly
    randomizeImages(images) {
      const shuffled = images.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
      }
      return shuffled;
    },
  },
};
</script>



<style scoped>
/* Gallery Div Styles */

/* Force each image to fully cover its slot */
.gallery-img {
  flex: 0 0 100%;         /* each image takes 100% of the container width */
  width: 100%;
  height: 100%;
  object-fit: cover;      /* fills without distortion */
  object-position: center;
  transition: transform 0.5s ease;
  display: block;
}

.gallery-div {
  background: #fff;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
}

.small-div {
  height: 300px;
}

.vertical-div {
  height: 620px; /* matches 2 rows of minis */
}

.featured-div {
  height: 620px;
}

/* Image styles */
.small-div .gallery-img {
  width: 100%;
  height: 100%; /* fills the small-div */
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease;
  display: block;
}

.vertical-div .gallery-img,
.featured-div .gallery-img {
  width: 100%;
  height: 100%; /* fills the parent div */
  object-fit: cover;
  object-position: center;
  transition: transform 0.5s ease;
  display: block;
}

/* Hover effect */
.gallery-div:hover .gallery-img {
  transform: scale(1.05);
}

/* Slider animation */
/* Ensure slider takes full size of parent */
.slider {
  width: 100%;
  height: 100%;
  display: flex;
  animation: slide infinite linear;
}

@keyframes slide {
  0%   { transform: translateX(0%); }
  100% { transform: translateX(-100%); }
}

</style>
